import { ProjectPaymentType } from './projectPaymentType'

export const allowedProjectPaymentTypes: ProjectPaymentType[] = [
  ProjectPaymentType.MONTHLY,
  ProjectPaymentType.ANNUALLY,
  ProjectPaymentType.IN_THE_END,
]
